export default __webpack_public_path__ + "static/tech2-5d70c3331aa801b70ef383793ecb4377.png";